import useFocusOnMount from 'lib/hooks/useFocusOnMount'
import sortBy from 'lib/util/sortBy'
import FormGroup from 'pages/Home/admin/FormGroup/FormGroup'
import RecordedWebinarType from 'pages/Home/RecordedWebinarType'
import Series from 'pages/Home/Series'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

export interface WebinarSelectorProps {
  selectedId?: string
  webinars: RecordedWebinarType[]
  onChange: (e: React.ChangeEvent<HTMLSelectElement>)=> void
}

export default function WebinarSelector(props: WebinarSelectorProps): JSX.Element {
  const { selectedId, webinars, onChange } = props
  const [t] = useTranslation()
  const inputEl = useRef(null)
  useFocusOnMount(inputEl)
  const groups: Record<string, RecordedWebinarType[]> = {}
  const seriesByTitle: Record<string, Series> = {}

  webinars.forEach(webinar => {
    seriesByTitle[webinar.series.title] = webinar.series

    const seriesTitle = webinar.series.title

    if (!groups[seriesTitle]) {
      groups[seriesTitle] = []
    }

    groups[seriesTitle].push(webinar)
  })

  for (const seriesTitle in groups) {
    groups[seriesTitle] = sortBy(groups[seriesTitle], webinar => webinar.title)
  }

  return (
    <FormGroup.Select ref={inputEl} name="recordedWebinarId" value={selectedId} onChange={onChange}>
      <option value="">{t('home.upcomingWebinarsSection.admin.addDialog.selectPlaceholder')}</option>
      {Object.keys(groups)
        .sort()
        .map(seriesTitle => (
          <optgroup key={seriesByTitle[seriesTitle].id} label={seriesTitle}>
            {groups[seriesTitle].map(recordedWebinar => (
              <option key={recordedWebinar.id} value={recordedWebinar.id}>
                {recordedWebinar.title}
              </option>
            ))}
          </optgroup>
        ))}
    </FormGroup.Select>
  )
}
